import { render, staticRenderFns } from "./CaseSwiper.vue?vue&type=template&id=3136a67a&scoped=true&"
import script from "./CaseSwiper.vue?vue&type=script&lang=js&"
export * from "./CaseSwiper.vue?vue&type=script&lang=js&"
import style0 from "./CaseSwiper.vue?vue&type=style&index=0&id=3136a67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3136a67a",
  null
  
)

export default component.exports